import React from 'react';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function MobileSelectOptions({
  options
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: options.map(option => /*#__PURE__*/_jsx("option", {
      value: option.id,
      "data-testid": option.id,
      children: option.label
    }, option.id))
  });
}